module.exports = __webpack_public_path__ + "img/Employes.31dcf514.svg";